import messages from './lang/messages.js'

export { 
    postingsListPage,
    spontaneousApplicationPage,
    postingDetailsPage, 
    selfServiceLink, 
    errorMessage, 
    inlineError, 
    successMessage, 
    attachmentErrorMessage, 
    preloader 
}

var privateTemplates = {};

function postingsListPage (postings, filters, isFiltered, columns) {
    var noResultFound = postings.length == 0;
    var html = 
        '<div id="manitouPostingsContainer" class="row">' +
            '<h3 class="manitouTitle">' + messages.titles.postingsListTitle + '</h3>' +
            '<div id="manitouSelfServiceContainer" class="col s12"></div>' +
            (!noResultFound ?
                '<div class="col s12 center-align manitouPaginationContainer">' +
                    '<div>' + 
                        messages.pagination.countResults + ' ' + 
                        '<span class="manitouLowerResult"></span> ' + 
                        messages.pagination.countTo + ' ' + 
                        '<span class="manitouUpperResult"></span> ' + 
                        messages.pagination.countOf + ' ' + 
                        '<span class="manitouTotalResults"></span>' + 
                    '</div>' +
                    '<ul class="pagination"></ul>' +
                '</div>' :
                '')+
            (!noResultFound || isFiltered ? // Hides the filters if there is no postings to filter
                '<div class="col s12">' +
                    privateTemplates.postingsFilters(filters, isFiltered) +
                '</div>' :
                '') +
            '<div class="col s12">' +
                (noResultFound ?
                    privateTemplates.noPostingsFound(isFiltered) :
                    privateTemplates.postingsTable(postings, columns)) +
            '</div>' +
            (!noResultFound ?
                '<div class="col s12 center-align manitouPaginationContainer">' +
                    '<div>' + 
                        messages.pagination.countResults + ' ' + 
                        '<span class="manitouLowerResult"></span> ' + 
                        messages.pagination.countTo + ' ' + 
                        '<span class="manitouUpperResult"></span> ' + 
                        messages.pagination.countOf + ' ' + 
                        '<span class="manitouTotalResults"></span>' + 
                    '<div>' +
                    '<ul class="pagination"></ul>' +
                '</div>' :
                '') +
        '</div>';
    return html;
};

/*  The extraAttachments is an array of objects following this model:
        {label: 'label', documentTypeId: 2, isRequired: true} 
    The customSelectionLists is an array of objects following this model:
        {
           label: 'field label',
            isRequired: true,
            multipleSelections: false,
            otherManualOption: false,
            options: [
                {
                    label: 'label', 
                    value: value
                }
            ]
        } */
function spontaneousApplicationPage (extraAttachments, resumeAttachmentId, displayComment, customSelectionLists) {
    var html =
        '<div id="manitouSpontaneousApplicationContainer" class="row">' +
            '<div class="col s12">' +
                privateTemplates.applicationForm('', messages.titles.spontaneousApplication, 
                    messages.text.spontaneousApplication, extraAttachments, resumeAttachmentId, displayComment, customSelectionLists) +
            '</div>' +
        '</div>';
    return html;
};

/*  The extraAttachments is an array of objects following this model:
        {label: 'label', documentTypeId: 2, isRequired: true} 
    The customSelectionLists is an array of objects following this model:
        {
           label: 'field label',
            isRequired: true,
            multipleSelections: false,
            otherManualOption: false,
            options: [
                {
                    label: 'label', 
                    value: value
                }
            ]
        } */
function postingDetailsPage (postingDetails, extraAttachments, resumeAttachmentId, displayComment, customSelectionLists) {
    var html =
        '<div id="manitouPostingDetailsContainer" class="row">' +
            privateTemplates.backToPostingsButton() +
            '<div class="col s12 xl7">' +
                privateTemplates.postingDetails(postingDetails) +
            '</div>' +
            '<div class="col s12 xl5">' +
                privateTemplates.applicationForm(postingDetails.id, messages.titles.applicationForm, null, 
                    extraAttachments, resumeAttachmentId, displayComment, customSelectionLists) +
            '</div>' +
            privateTemplates.backToPostingsButton() +
        '</div>';
    return html;
};

function selfServiceLink (url) {
    var html =
        
        '<h6>' + 
            messages.text.selfService +
        '</h6>' +
        '<a class="waves-effect waves-light btn" href="' + url + '" target="_blank">' + 
            messages.buttons.selfService + 
        '</a>';
    return html;
};

function errorMessage(errorMessage) {
    var html =
        '<div class="row manitouErrorContainer center-align">' +
            '<div class="col s12">' +
                '<i class="material-icons medium">error_outline</i>' +
            '</div>' +
            '<div class="col s12">' +
                '<h5 class="flow-text">' + 
                    errorMessage +
                '</h5>' +
                '<h5 class="flow-text">' + 
                    messages.errors.genericTryAgain +
                '</h5>' +
            '</div>' +
        '</div>';
        return html;
};

function inlineError (errorMessage) {
    var html =
        '<div>' + errorMessage + '</div>';
    return html;
};

function successMessage (successMessage) {
    var html =
    '<div class="col s12 manitouSuccessMessage">' + 
        '<h5>' + successMessage + '</h5>' +
    '</div>';
    return html;
};

function attachmentErrorMessage (fileName) {
    var html =
    '<div class="col s12 manitouErrorMessage">' + 
        '<h5>' + messages.errors.addExtraAttachment.replace('{{fileName}}', (fileName ? fileName : '')) + '</h5>' +
    '</div>';
    return html;
};

function preloader () {
    var html =
        '<div class="row center-align manitouPreloaderContainer">' +
            '<div class="preloader-wrapper big active center-align">' +
                '<div class="spinner-layer spinner-blue-only">' +
                '<div class="circle-clipper left">' +
                    '<div class="circle"></div>' +
                '</div><div class="gap-patch">' +
                    '<div class="circle"></div>' +
                '</div><div class="circle-clipper right">' +
                    '<div class="circle"></div>' +
                '</div>' +
                '</div>' +
            '</div>' +
        '</div>';
    return html;
};

privateTemplates.postingsFilters = function (filters, areFiltersActive) {
    var filtersHtml = '';
    $.each(filters, function (filterType, filtersList) {
        var filterOptionsHtml = '';

        $.each(filtersList, function (index, filter) {
            filterOptionsHtml +=
                '<option value="' + filter.id + '">' + filter.value + '</option>';
        });

        filtersHtml +=
            '<div class="input-field col s12 m6 l4">' +
                '<select class="manitouFilter" data-filter-type="' + filterType + '">' +
                    '<option value="0" selected>' + messages.defaultOptions[filterType] + '</option>' +
                    filterOptionsHtml +
                '</select>' +
                '<label>' + messages.labels[filterType] + '</label>' +
            '</div>';
    });
    
    var html = 
        '<ul class="collapsible">' +
            '<li ' + (areFiltersActive ? 'class="active"' : '') + '>' +
                '<div class="collapsible-header">' +
                    '<i class="material-icons">filter_list</i>' + 
                    messages.buttons.filterResults + 
                '</div>' +
                '<div class="collapsible-body">' + 
                    '<div class="row">' +
                        filtersHtml +
                    '</div>' +
                    '<div class="row">' +
                        '<div class="col s12">' +
                            '<a class="waves-effect waves-light btn manitouApplyFiltersButton">' +
                                messages.buttons.applyFilters +
                            '</a>' + 
                        '</div>' +
                        '<div class="col s12">' +
                            '<a class="waves-effect manitouResetFiltersButton manitouLink">' +
                                messages.buttons.resetFilters +
                            '</a>' + 
                        '</div>' +
                    '</div>' +
                '</div>' +
            '</li>' +
        '</ul>';
    return html;
};

privateTemplates.postingsTable = function (postings, columns) {
    var postingsHtml = '';
    $.each(postings, function (index, posting) {
        postingsHtml +=
            '<tr>' +
                columns.reduce(
                    function(columnsHtml, columnName) {
                        return columnsHtml + '<td>' + (posting[columnName] ? posting[columnName] : '') + '</td>';
                    }, ''
                ) +
                // '<td>' + posting.title + '</td>' +
                // '<td>' + posting.institution + '</td>' +
                // '<td>' + posting.location + '</td>' +
                // '<td>' + posting.deadline + '</td>' +
                '<td>' + 
                    '<a class="waves-effect waves-light btn manitouPostingButton" ' +
                        'data-posting-id="' + posting.id + '">' + 
                        messages.buttons.apply + 
                    '</a>' +
                '</td>' +
            '</tr>';
    });
    var html = 
        '<div id="manitouPostingsTable" class="row">' +
            '<div id="manitouPostingTableContainer" class="col s12">' +
                '<table class="highlight">' +
                    '<thead>' +
                    '<tr>' +
                        columns.reduce(
                            function(headersHtml, columnName) {
                                return headersHtml + '<th>' + messages.tableHeaders[columnName] + '</th>';
                            }, ''
                        ) +
                        // '<th>' + messages.tableHeaders.title + '</th>' +
                        // '<th>' + messages.tableHeaders.institution + '</th>' +
                        // '<th>' + messages.tableHeaders.location + '</th>' +
                        // '<th>' + messages.tableHeaders.deadline + '</th>' +
                        '<th></th>' +
                    '</tr>' +
                    '</thead>' +

                    '<tbody>' +
                        postingsHtml +
                    '</tbody>' +
                '</table>'
            '</div>' +
        '</div>';
    return html;
};

privateTemplates.postingDetails = function (postingDetails) {
    var contentHeaderHtml = '';
    var contentBodyHtml = '';
    var contentFooterHtml = '';

    $.each(postingDetails.contentHeader, function (index, content) {
        contentHeaderHtml +=
            '<div class="row">' +
                '<div class="col s12 m3 manitouLabel">' +
                    content.label +
                '</div>' +
                '<div class="col s12 m9">' +
                    content.value +
                '</div>' +
            '</div>'; 
    });

    $.each(postingDetails.contentBody, function (index, content) {
        contentBodyHtml +=
            '<div class="row">' +
                '<div class="col s12 m3">' +
                    '<div class="row manitouLabelRow">' +
                        '<div class="col m10 valign-wrapper">' +
                            '<span class="manitouLabel">' + content.label + '</span>' +
                        '</div>' +
                    '</div>' +
                '</div>' +
                '<div class="col s12 m9">' +
                    content.value +
                '</div>' + 
            '</div>'; 
    });

    $.each(postingDetails.contentFooter, function (index, content) {
        contentFooterHtml +=
            '<div class="row">' +
                '<div class="col s12 m3 manitouLabel">' +
                    content.label +
                '</div>' +
                '<div class="col s12 m9">' +
                    content.value +
                '</div>' +
            '</div>'; 
    });

    var html = 
        '<div id="manitouPostingDetails" class="row">' +
            '<div class="col s12">' +
                '<div class="row">' +
                    '<div class="col s12 valign-wrapper manitou-logo-container">' +
                        '<img id="manitouLogo" class="responsive-img" src="' + postingDetails.logoURL + '"></img>' + 
                        '<div id="manitouSocialsContainer">' +
                            '<a href="' + postingDetails.facebookURL + '" class="waves-effect waves-dark btn-flat" ' +
                                'title="' + messages.buttons.facebookTooltip + '" target="_blank">' + 
                                '<i class="fab fa-fw fa-facebook-f"></i>' + 
                            '</a>' +
                            '<a href="' + postingDetails.twitterURL + '" class="waves-effect waves-dark btn-flat" ' +
                                'title="' + messages.buttons.twitterTooltip + '" target="_blank">' + 
                                '<i class="fab fa-fw fa-twitter"></i>' +
                            '</a>' +
                            '<a href="' + postingDetails.linkedInURL + '" class="waves-effect waves-dark btn-flat" ' +
                                'title="' + messages.buttons.linkedinTooltip + '" target="_blank">' + 
                                '<i class="fab fa-fw fa-linkedin-in"></i>' +
                            '</a>' +
                            '<a class="waves-effect waves-dark btn-flat" href="mailto:?subject=' + 
                                messages.email.shareSubject + '&body=<' + postingDetails.sharingURL + '>"' +
                                'title="' + messages.buttons.mailTooltip + '">' + 
                                '<i class="fas fa-fw fa-envelope"></i>' +
                            '</a>' +
                        '</div>' +
                    '</div>' +
                    '<div class="divider col s12"></div>' +
                    '<div class="col s12 manitou-title-container">' +
                        '<h3>' + postingDetails.title + '</h3>' +
                    '</div>' +
                    '<div class="divider col s12"></div>' +
                '</div>' +
            '</div>' +
            '<div class="col s12">' +
                '<div id="manitouContentHeader" class="row">' +
                    '<div class="col s12">' +
                        contentHeaderHtml +
                    '</div>' +
                '</div>' +
                '<div class="divider"></div>' +
                '<div id="manitouContentBody" class="row">' +
                    '<div class="col s12">' +
                        contentBodyHtml +
                    '</div>' +
                '</div>' +
                '<div class="divider"></div>' +
                '<div id="manitouContentFooter" class="row">' +
                    '<div class="col s12">' +
                        contentFooterHtml +
                    '</div>' +
                '</div>' +
            '</div>' +
        '</div>';

    return html;
};

/*  The extraAttachments is an array of objects following this model:
        {label: 'label', documentTypeId: 2, isRequired: true} 
    The customSelectionLists is an array of objects following this model:
        {
           label: 'field label',
            isRequired: true,
            multipleSelections: false,
            otherManualOption: false,
            options: [
                {
                    label: 'label', 
                    value: value
                }
            ]
        } */
privateTemplates.applicationForm = function (postingId, title, text, extraAttachments, resumeAttachmentId, displayComment, customSelectionLists) {
    var extraAttachmentsHtml = '';
    $.each(extraAttachments, function (index, attachment) {
        extraAttachmentsHtml += privateTemplates.attachmentField(
            attachment.label, attachment.documentTypeId, attachment.isRequired, 'manitouFile-' + index, 
            'manitouFileName-' + index, 'manitouExtraAttachment'
        );
    });

    var customSelectFieldsHtml = '';
    $.each(customSelectionLists, function (index, selectList) {
        customSelectFieldsHtml += privateTemplates.customSelectField(
            selectList.label, selectList.isRequired, selectList.multipleSelections, 
            selectList.otherManualOption, selectList.options, 'manitouCustomSelect-' + index,
            selectList.columnWidth
        );
    });
    
    var html =
        '<div id="manitouApplicationForm" class="row card-panel">' +
            '<form class="col s12">' +
                '<div class="row">' +
                    '<div class="col s12 center-align">' +
                        '<h4>' + title + '</h4>' +
                        (text ? '<p>' + text + '</p>': '') +
                    '</div>' +
                '</div>' +
                '<div class="row manitouFormRow">' +
                    '<div class="input-field col s6">' +
                        '<input id="manitouFirstName" type="text" class="validate" maxlength="200" required>' +
                        '<label for="manitouFirstName">' + messages.labels.firstName + ' *</label>' +
                        '<span class="helper-text" data-error="' + messages.validations.firstNameError +
                            '"></span>' +
                    '</div>' +
                    '<div class="input-field col s6">' +
                        '<input id="manitouLastName" type="text" class="validate" maxlength="100" required>' +
                        '<label for="manitouLastName">' + messages.labels.lastName + ' *</label>' +
                        '<span class="helper-text" data-error="' + messages.validations.lastNameError +
                            '"></span>' +
                    '</div>' +
                '</div>' +
                '<div class="row manitouFormRow">' +
                    '<div class="input-field col s12">' +
                        '<input id="manitouEmail" type="email" class="validate" maxlength="250" ' +
                            'title="' + messages.validations.emailTooltip + '" required>' +
                        '<label for="manitouEmail">' + messages.labels.email + ' *</label>' +
                        '<span class="helper-text" data-error="' + messages.validations.emailError + '" ' +
                            'data-success="' + messages.validations.emailCorrect + '"></span>' +
                    '</div>' +
                '</div>' +
                '<div class="row manitouFormRow">' +
                    '<div class="input-field col s12">' +
                        '<input id="manitouPhone" type="text" class="validate" maxlength="25">' +
                        '<label for="manitouPhone">' + messages.labels.phone + '</label>' +
                        '<span class="helper-text" data-error="" data-success=""></span>' +
                    '</div>' +
                '</div>' +
                '<div class="row manitouFormRow">' +
                    customSelectFieldsHtml +
                '</div>' +
                (displayComment ? privateTemplates.commentField(false): '') +
                '<div class="row manitouFormRow">' +
                    privateTemplates.attachmentField(messages.labels.resume, resumeAttachmentId, true, 'manitouResumeFile', 'manitouResumeFileName') +
                    extraAttachmentsHtml +
                '</div>' +
                '<div class="row">' +
                    '<div id="manitouApplicationFormErrors" class="col s12">' +
                    '</div>' +
                    '<div class="col s12 center-align">' +
                        '<a id="manitouApplyButton" class="waves-effect waves-light btn-large" ' +
                            (postingId ? 'data-posting-id="' + postingId + '"' : '') + '>' +
                            '<i class="material-icons right">send</i>' +
                            messages.buttons.sendApplication +
                        '</a>' +
                    '</div>' +
                '</div>' +
            '</form>' +
        '</div>';
    return html;
};

privateTemplates.noPostingsFound = function(isFiltered) {
    var html = 
        '<div class="row manitouNoPostingsFound">' +
            '<div class="col s12">' +
                '<h5>' + 
                    (isFiltered ? 
                        messages.noDataFound.noSearchResults : 
                        messages.noDataFound.noPostings) + 
                '</h5>' +
            '</div>' +
            (isFiltered ?
                '<div class="col s12">' +
                    '<a class="waves-effect manitouResetFiltersButton manitouLink">' +
                        messages.buttons.resetFilters +
                    '</a>' + 
                '</div>' :
                '') +
        '</div>';
    return html;
};

privateTemplates.backToPostingsButton = function () {
    var html = 
        '<div class="col s12">' +
            '<a class="waves-effect manitouBackToPostingsButton manitouLink">' +
                messages.buttons.backToPostings +
            '</a>' + 
        '</div>';
    return html;
};

privateTemplates.attachmentField = function (label, documentTypeId, isRequired, idFile, idFileName, classes) {
    var html =
        '<div class="file-field input-field col s12' + (classes ? ' ' + classes : '') + '">' +
            '<div class="btn">' +
                '<span>' + messages.buttons.file + '</span>' +
                '<input ' + (idFile ? 'id="' + idFile + '" ' : '') + 'type="file" ' +
                    (documentTypeId ? 'data-attachment-type="' + documentTypeId + '" ' : '') +
                    (isRequired ? 'required' : '') + '>' +
            '</div>' +
            '<div class="file-path-wrapper">' +
                '<input ' + (idFileName ? 'id="' + idFileName + '" ' : '') + 'class="file-path validate" type="text" ' +
                    'placeholder="' + label + (isRequired ? ' *' : '') + '" maxlength="128" ' + (isRequired ? 'required' : '') + '>' +
                '<label ' + (idFileName ? 'for="' + idFileName + '"' : '') + '></label>' +
                '<span class="helper-text" data-error="' + messages.validations.attachmentError + '"></span>' +
            '</div>' +
        '</div>';
    return html;
}

privateTemplates.commentField = function (isRequired) {
    var html =
        '<div class="row manitouFormRow">' +
            '<div class="input-field col s12">' +
                '<textarea id="manitouComment" class="materialize-textarea-no-auto-resize validate" maxlength="2000"' +
                    (isRequired ? ' required': '') + '>' +
                '</textarea>' +
                '<label for="manitouComment">' + messages.labels.comment + (isRequired ? ' *' : '') + '</label>' +
                '<span class="helper-text" data-error="' + messages.validations.requiredFieldError + '"></span>' +
            '</div>' +
        '</div>';
    return html;
}

privateTemplates.customSelectField = function (label, isRequired, multipleSelections, otherManualOption, options, selectId, columnWidth) {
    var optionsHtml = '';
    // Add an empty default value for single selection dropdown
    if (multipleSelections !== true) {
        optionsHtml += '<option value="" selected></option>'
    }

    options.forEach(
        function(option) {
            optionsHtml += '<option value="' + option.value + '">' + option.label + '</option>';
        }
    );
    // Add an Other option with a field for a custom manual answer
    if (otherManualOption) {
        optionsHtml += '<option value="-1">' + messages.defaultOptions.other + '</option>';
    }
    
    var html = 
        '<div class="input-field col s' + (columnWidth ? columnWidth : 12) + '">' +
            '<select class="manitouSelectToComment' + 
                (otherManualOption ? ' manitouSelectWithOtherOption' : '') + 
                '" id="' + (selectId ? selectId : '') + '" data-label="' + label + '"' + 
                (isRequired ? ' required' : '') + (multipleSelections ? ' multiple' : '') + '>' +
                optionsHtml +
            '</select>' +
            '<label for="' + (selectId ? selectId : '') + '">' + 
                label + (isRequired ? ' *' : '') + 
            '</label>' +
            '<span class="helper-text" data-error="' + messages.validations.requiredFieldError + '"></span>' +
        '</div>';

    if (otherManualOption) {
        html += 
            '<div class="input-field col s12 manitouOtherField" hidden>' +
                '<input id="' + (selectId ? selectId + '-otherField' : '') + '" type="text" class="validate" ' + 
                    'maxlength="200" required>' +
                '<label for="' + (selectId ? selectId + '-otherField' : '') + '">' + 
                    messages.labels.other + ' (' + label + ')' + ' *' +
                '</label>' +
                '<span class="helper-text" data-error="' + messages.validations.requiredFieldError + '"></span>' +
            '</div>';
    }

    return html;
}